// utils/versionInfo.ts
import { version } from '../../package.json';

declare const __APP_VERSION__: {
    branch: string;
    commit: string;
    buildDate: string;
};

export interface VersionInfo {
    environment: string;
    version: string;
    buildDate: string;
    gitBranch: string;
    gitCommit: string;
}

/**
 * Returns environment and version information baked in at build time.
 * Git metadata comes from __APP_VERSION__ (injected by vite.config.mjs define).
 * VITE_ENV_NAME still comes from the .env file as it's environment-specific config,
 * not build metadata.
 */
const getVersionInfo = (): VersionInfo => {
    const environment = import.meta.env.VITE_ENV_NAME || 'development';

    // __APP_VERSION__ is a compile-time constant - guaranteed present if vite.config.mjs is correct
    const { branch: gitBranch, commit: gitCommit, buildDate } = __APP_VERSION__;

    const shortCommit = gitCommit ? gitCommit.substring(0, 7) : '';

    let versionString = version;
    if (gitBranch && shortCommit) {
        versionString = `${version} (${gitBranch}:${shortCommit})`;
    } else if (shortCommit) {
        versionString = `${version} (${shortCommit})`;
    } else if (gitBranch) {
        versionString = `${version} (${gitBranch})`;
    }

    const formattedDate = buildDate ? new Date(buildDate).toLocaleString() : '';

    return {
        environment,
        version: versionString,
        buildDate: formattedDate,
        gitBranch,
        gitCommit: shortCommit,
    };
};

export default getVersionInfo;
